module.exports = __webpack_public_path__ + "static/img/lunbo1.680be70a.png";